import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { showSuccessMessage } from 'redux/slices/notification';
import { ReactComponent as FbLogo } from 'assets/icons/facebook-f.svg';
import { ReactComponent as TwitterLogo } from 'assets/icons/twitter.svg';
import { ReactComponent as LinkIcon } from 'assets/icons/link.svg';

import Share from 'services/share';

const ShareActions = ({ amount, product_url, homepage_url, productsCount }) => {
  const dispatch = useDispatch();

  const content = useMemo(() => {
    if (productsCount === 1) {
      return {
        text: `I just donated €${amount}, join me in supporting this great cause.`,
        url: encodeURIComponent(product_url),
      };
    } else {
      return {
        text: 'Join me in supporting the great causes on Hailopay.',
        url: encodeURIComponent(homepage_url),
      };
    }
  }, [amount, homepage_url, product_url, productsCount]);

  const socialShare = new Share(content.url, content.text);

  const onClickCopy = () => {
    dispatch(showSuccessMessage('Link copied to clipboard!'));
    return socialShare.copy;
  };

  return (
    <div
      className="grid lg:grid-flow-col lg:grid-cols-3 items-center lg:mt-9 lg:mb-12 gap-2.5 lg:gap-3.5 w-full lg:w-auto"
      data-testid="share-actions"
    >
      <a
        href={socialShare.facebook}
        target="_blank"
        rel="noreferrer"
        className="btn btn-blue flex items-center justify-center text-center min-w-max lg:px-1"
      >
        <FbLogo
          width="10px"
          height="16px"
          className="text-white fill-current mr-3.5 flex-shrink-0"
        />
        Facebook
      </a>
      <a
        href={socialShare.twitter}
        target="_blank"
        rel="noreferrer"
        className="btn btn-blue flex items-center justify-center text-center min-w-max lg:px-1"
      >
        <TwitterLogo
          width="16px"
          height="16px"
          className="text-white fill-current mr-3.5 flex-shrink-0"
        />
        <p>Twitter</p>
      </a>
      <button
        onClick={onClickCopy}
        className="btn btn-blue flex items-center justify-center text-center min-w-max lg:px-1"
      >
        <LinkIcon
          width="14px"
          height="16px"
          className="text-white fill-current mr-3.5 flex-shrink-0"
        />
        <p>Copy Link</p>
      </button>
    </div>
  );
};

export default ShareActions;
